/**
 * Mixin for shared warehouse filter computed properties and methods.
 * Used by WarehouseFiltersDesktop, WarehouseFiltersMobile, and WarehouseTabPurchase.
 *
 * Provides:
 *   - computed: showItems, documentTypeItems, statusKeyMap, statusTypes,
 *               statusColors, transactionTypes
 *   - methods: updateFilter, getStatusColor
 */
export default {
  computed: {
    showItems() {
      return [
        {
          text: this.$t("meals_in_meals"),
          value: "daily",
        },
        {
          text: this.$t("meal_in_groops"),
          value: "daily-group",
        },
      ];
    },
    documentTypeItems() {
      return [
        { name: this.$t("all"), value: null },
        { name: this.$t("warehouse.request_quote"), value: "request" },
        { name: this.$t("warehouse.purchase_order"), value: "order" },
      ];
    },
    /**
     * Maps status value → translation key.
     * Single source of truth for all status definitions.
     */
    statusKeyMap() {
      return {
        created: "status_created",
        sent: "status_sent",
        confirm: "status_confirmed_by_supplier",
        "confirm-half": "status_partially_confirmed_by_supplier",
        "reject-supplier": "status_rejected_by_supplier",
        "changed-in-progress": "status_change_in_progress",
        "waiting-to-other-supplier": "status_waiting_for_another_supplier",
        reject: "status_rejected_by_us",
        delivered: "delivered_11",
        "delivered-half": "status_partially_delivered",
        "on-checking": "status_on_checking",
        "reject-on-arrived": "status_rejected_on_arrival",
        accept: "status_accepted",
        closed: "status_closed",
        undefined: "status_undefined",
      };
    },
    /**
     * Status items for filter dropdowns (includes "all" and "open").
     * Derived from statusKeyMap.
     */
    statusTypes() {
      return [
        { name: this.$t("all"), value: null },
        { name: this.$t("status_open"), value: "open" },
        ...Object.entries(this.statusKeyMap).map(([value, key]) => ({
          name: this.$t(key),
          value,
        })),
      ];
    },
    transactionTypes() {
      return [
        { text: this.$t("all"), value: null },
        { text: this.$t("warehouse.request_quote"), value: "request" },
        { text: this.$t("warehouse.purchase_order"), value: "order" },
        { text: this.$t("warehouse.warehouse_replenishment"), value: "entry" },
        { text: this.$t("warehouse.shipping_from_warehouse"), value: "exit" },
        { text: this.$t("warehouse.write_off"), value: "write-off" },
        { text: this.$t("warehouse.return_goods"), value: "return" },
      ];
    },
  },
  methods: {
    updateFilter(key, value) {
      this.$emit("update:filter", { key, value });
    },
    getStatusColor(status) {
      const colors = {
        created: "grey",
        sent: "blue",
        confirm: "success",
        "confirm-half": "warning",
        "reject-supplier": "error",
        "changed-in-progress": "orange",
        "waiting-to-other-supplier": "purple",
        reject: "error",
        delivered: "success",
        "delivered-half": "warning",
        "on-checking": "info",
        "reject-on-arrived": "error",
        accept: "success",
        closed: "grey darken-2",
      };
      return colors[status] || "grey";
    },
  },
};
